import { render, staticRenderFns } from "./FamilyProduct.vue?vue&type=template&id=5a3766dc&scoped=true"
import script from "./FamilyProduct.vue?vue&type=script&lang=js"
export * from "./FamilyProduct.vue?vue&type=script&lang=js"
import style0 from "./FamilyProduct.vue?vue&type=style&index=0&id=5a3766dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3766dc",
  null
  
)

export default component.exports